/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./volume-controller.vue?vue&type=template&id=a4ee7738&scoped=true&"
import script from "./volume-controller.vue?vue&type=script&lang=js&"
export * from "./volume-controller.vue?vue&type=script&lang=js&"
import style0 from "./volume-controller.vue?vue&type=style&index=0&id=a4ee7738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ee7738",
  null
  
)

export default component.exports